// Immutably sets a value at a dotted path inside a nested object/array.
// Numeric segments are treated as array indices: "services.items.0.name".
// Missing intermediate nodes are created (object for non-numeric next key,
// array for numeric next key).
export function setByPath<T>(obj: T, path: string, value: unknown): T {
  if (!path) return value as T;
  const parts = path.split('.');

  function go(node: unknown, i: number): unknown {
    const key = parts[i]!;
    const isIndex = /^\d+$/.test(key);
    const last = i === parts.length - 1;
    const nextIsIndex = !last && /^\d+$/.test(parts[i + 1]!);

    if (isIndex) {
      const idx = Number(key);
      const arr = Array.isArray(node) ? node.slice() : [];
      arr[idx] = last ? value : go(arr[idx] ?? (nextIsIndex ? [] : {}), i + 1);
      return arr;
    }

    const o =
      node && typeof node === 'object' && !Array.isArray(node)
        ? { ...(node as Record<string, unknown>) }
        : ({} as Record<string, unknown>);
    o[key] = last ? value : go(o[key] ?? (nextIsIndex ? [] : {}), i + 1);
    return o;
  }

  return go(obj, 0) as T;
}
